import styled from 'styled-components';

import { ConnectivityIconWrapperProps } from './GetConnectivityIconAndStatus.utils';

export const ConnectivityIconWrapper = styled.div<ConnectivityIconWrapperProps>`
  display: flex;
  height: 100%;
  width: ${({ size }) => size};
  justify-content: center;
  align-items: center;
  z-index: 3;

  .connectivity-icon {
    height: 100%;
  }
`;
